export function decodeAtlasPromptParam(encoded: string | null | undefined): string | undefined {
    const trimmed = encoded?.trim();
    if (!trimmed) {
        return undefined;
    }
    try {
        const base64 = trimmed.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
        const binary = atob(padded);
        const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
        return new TextDecoder().decode(bytes);
    } catch {
        return undefined;
    }
}
